import React, { createContext, useContext, useState, useEffect } from "react";
import { logout as authLogout } from "../services/authService";
import { getSecureItem, setSecureItem } from "../utils/LocalStorageManager";

interface UserContextType {
  user: any;
  setUser: (user: any) => void;
  logout: () => void;
}

const UserContext = createContext<UserContextType | undefined>(undefined);

export const UserProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [user, setUser] = useState<any>(null);

  useEffect(() => {
    const token = getSecureItem("access_token");
    if (token) {
      const storedUser = getSecureItem("user");
      if (storedUser) setUser(storedUser);
    }
  }, []);

  // 2. Wrap the state setter to ensure it saves to LocalStorage automatically
  const handleSetUser = (userData: any) => {
    setUser(userData);
    if (userData) {
      setSecureItem("user", userData);
    } else {
      localStorage.removeItem("user");
    }
  };

  const logout = async () => {
    await authLogout();
    setUser(null);
    localStorage.removeItem("user");
    localStorage.removeItem("token");
  };

  return (
    <UserContext.Provider value={{ user, setUser: handleSetUser, logout }}>
      {children}
    </UserContext.Provider>
  );
};

// Custom hook for easier usage
export const useUser = () => {
  const context = useContext(UserContext);
  if (!context) throw new Error("useUser must be used within a UserProvider");
  return context;
};
